import { EMPLOYEE_ROLE_DISPLAY_STR, TEmployeeRole, TRESPONSE_EMPLOYEE_LIST } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import _ from 'lodash';

export const EMPLOYEE_LIST_TABLE_MODEL = {
  createModel: (
    items: TRESPONSE_EMPLOYEE_LIST['employeesWithAssignments'],
    isSelectedFactoryDefaultFactory: boolean,
    employeeRole?: TEmployeeRole[number] | undefined,
  ) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        headerConfig: _.compact([
          {
            type: 'TEXT_CELL',
            text: 'table_model.NAME',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.EMPLOYEEID',
          },
          employeeRole === 'FACTORY_GROUP_ADMIN'
            ? {
                type: 'TEXT_CELL',
                text: 'table_model.FACTORYID',
              }
            : undefined,
          {
            type: 'TEXT_CELL',
            text: 'table_model.CONTACTDETAILS',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.ROLE',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.USERNAME',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.DEPARTMENT',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.FLOOR',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.SECTION',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.LINE',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.MACHINETYPES',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.ISSUECATEGORIES',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.SHIFT',
          },
          isSelectedFactoryDefaultFactory && {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 32,
          },
          isSelectedFactoryDefaultFactory && {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 32,
          },
        ]),
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          isSelected: false,
          cells: _.compact([
            {
              type: 'TEXT_CELL',
              text: item.employee.name,
            },
            {
              type: 'TEXT_CELL',
              text: item.employee.employeeId,
            },
            employeeRole === 'FACTORY_GROUP_ADMIN'
              ? {
                  type: 'TEXT_CELL',
                  text: item.employee.factoryId,
                }
              : undefined,
            {
              type: 'TEXT_LIST_CELL',
              text: [
                ...(item.employee.emailId ? [item.employee.emailId] : []),
                ...(item.employee.contactNumber ? [item.employee.contactNumber] : []),
              ],
            },
            {
              type: 'TEXT_CELL',
              text: EMPLOYEE_ROLE_DISPLAY_STR[item.employee.role],
            },
            {
              type: 'TEXT_CELL',
              text: item.employee.username,
            },
            {
              type: 'TEXT_LIST_CELL',
              text: item.assignedLocations.map((v) => {
                switch (v.location.locationType) {
                  case 'PRODUCTION':
                    return v.location.department;
                  default:
                    return '--';
                }
              }),
            },
            {
              type: 'TEXT_LIST_CELL',
              text: item.assignedLocations.map((v) => {
                switch (v.location.locationType) {
                  case 'FLOATING':
                  case 'PRODUCTION':
                  case 'FLOOR_NEEDLE_STORE':
                    return v.location.floor;
                  default:
                    return '--';
                }
              }),
            },
            {
              type: 'TEXT_LIST_CELL',
              text: item.assignedLocations.map((v) => {
                switch (v.location.locationType) {
                  case 'PRODUCTION':
                  case 'SECTION_NEEDLE_STORE':
                    return v.location.section || '--';
                  default:
                    return '--';
                }
              }),
            },
            {
              type: 'TEXT_LIST_CELL',
              text: item.assignedLocations.map((v) => {
                switch (v.location.locationType) {
                  case 'PRODUCTION':
                    return v.location.line;
                  default:
                    return '--';
                }
              }),
            },
            {
              type: 'TEXT_LIST_CELL',
              text: item.machineTypes,
            },
            {
              type: 'TEXT_LIST_CELL',
              text: item.issueCategories,
            },
            {
              type: 'TEXT_LIST_CELL',
              text: (item.shiftsOpt ?? []).map((s) =>
                s.shiftCategory ? `${s.shiftName} (${s.shiftCategory})` : s.shiftName,
              ),
            },
            isSelectedFactoryDefaultFactory && {
              type: 'ACTION_CELL',
              actionType: 'EDIT',
              asIcon: true,
            },
            isSelectedFactoryDefaultFactory && {
              type: 'ACTION_CELL',
              actionType: 'DELETE',
              asIcon: true,
            },
          ]),
        };
      },
    );
  },
};
